import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LoginForm, { LoginInputs } from "../../../components/LoginForm/LoginForm";
import * as actionCreator from "../../../actions";

interface LoginProps {};

const Login: React.FC<LoginProps> = () => {

    const dispatch = useDispatch();
    const [t] = useTranslation();
    const {isLoading} = useSelector( (store: any) => store.authReducer);

    const _handleOnSubmit = (data: LoginInputs) => {
        dispatch( actionCreator.authLogin(data.email, data.password) );
    }

    return(
        <div className="auth">
            <div className='box-center'>
            <div className='auth__wrapper'>

                <div className='auth__box'>
                    <div className="row">

                        <div className="col-12 col-md-6">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <img className="auth__logo" src={process.env.REACT_APP_AUTH_LOGO_URI || '/img/logo-cactus.png'} alt="logo" />
                            </div>
                        </div>

                        <div className="col-12 col-md-6 auth__form">
                            <p className="auth__heading">{t('login_welcome')}</p>
                            <p className="auth__subheading">{t('login_subtitle')}</p>
                            <LoginForm
                                onSubmit={_handleOnSubmit}
                                btnLoading={isLoading}
                            />
                        </div>

                    </div>
                </div>

                <p className="auth__register-hint">
                    {t('login_no_account')}{' '}
                    <Link to="/register">{t('login_register_link')}</Link>
                </p>

            </div>
            </div>
        </div>
    );

};

export default React.memo(Login);
